import { useEffect } from "react";
import {
  changeConfigurationActiveComponent,
  changeHelpActiveComponent,
} from "../../configurationSlice";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { changeCurrentProduct, selectRoles } from "../../../common/commonSlice";

export const ConfiguracionHelp = () => {
  const dispatch = useAppDispatch();
  const roles = useAppSelector(selectRoles);
  useEffect(() => {
    dispatch(changeConfigurationActiveComponent("Help"));
    dispatch(changeHelpActiveComponent("Documentacion Configuracion"));
    dispatch(changeCurrentProduct("Ayuda y Documentacion"));
  }, []);
  return (
    <div
      style={{
        overflow: "auto",
        color: "white",
        padding: "2% 2%",
        width: "100%",
        height: "100%",
      }}
    >
      <h2
        style={{
          fontWeight: "bold",
          fontSize: "52px",
        }}
      >
        Configuración y Administración
      </h2>
      <p>
        Esta sección permite entender como configurar y administrar lo
        relacionado a esta misma plataforma, es decir, el backoffice en el que
        se encuentra.
      </p>
      <p>
        Estos manuales le enseñarán a como navegar en la configuración y podrá
        realizar diferentes acciones, esta sección se divide en los siguientes
        manuales:
        <br />
        <br />
        <ul>
          <li>
            <strong>Configuración de la cuenta:</strong> Lo cual permite
            configurar permisos y cuenta del usuario propia, como cambio de
            nombre, contraseña, etc.
          </li>
          {(roles.includes("users.admin") ||
            roles.includes("users.create") ||
            roles.includes("users.edit") ||
            roles.includes("users.delete")) && (
            <li>
              <strong>Administración de usuarios:</strong> Lo cual permite, si
              es administrador, ver, crear, editar, desactivar y eliminar
              usuarios de su compañía, así como asignar roles y permisos según
              sus necesidades.
            </li>
          )}
          {roles.includes("users.audit") && (
            <li>
              <strong>Historial de Acciones:</strong>Herramienta que permite a
              los administradores ver y analizar las acciones que han realizado
              los usuarios del backoffice.
            </li>
          )}
        </ul>
      </p>
      <p>
        A continuación puedes visualizar y descargar los manuales de
        administración y configuración:
      </p>
      <h3
        style={{
          fontWeight: "bold",
          fontSize: "36px",
        }}
      >
        Configuración de la cuenta
      </h3>
      <p>
        Este manual permite entender como modificar tu información, restablecer
        tu contraseña y conocer el estado de tu cuenta.
      </p>
      <object
        data="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20CONFIGURACI%C3%93N%20DE%20CUENTA.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          Descarga alternativa:{" "}
          <a href="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20CONFIGURACI%C3%93N%20DE%20CUENTA.pdf">
            Si no se ve puede dar click aquí para descargar el PDF
          </a>
        </p>
      </object>

      {(roles.includes("users.admin") ||
        roles.includes("users.create") ||
        roles.includes("users.edit") ||
        roles.includes("users.delete")) && (
        <>
          <h3
            style={{
              fontWeight: "bold",
              fontSize: "36px",
            }}
          >
            Administración de usuarios
          </h3>
          <p>
            Este manual permite entender como crear, editar, eliminar, suspender
            usuarios, por otro lado, permite crear roles de permisos para
            asignar permisos de manera más efectiva. <br />
            También el restablecimiento de contraseñas, historial de cambios,
            entre otros.
          </p>
          <object
            data="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20ADMINISTRACI%C3%93N%20DE%20USUARIOS.pdf"
            type="application/pdf"
            width="100%"
            height="100%"
          >
            <p>
              Descarga alternativa:{" "}
              <a href="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20ADMINISTRACI%C3%93N%20DE%20USUARIOS.pdf">
                Si no se ve puede dar click aquí para descargar el PDF
              </a>
            </p>
          </object>
        </>
      )}
      {roles.includes("users.audit") && (
        <>
          <h3
            style={{
              fontWeight: "bold",
              fontSize: "36px",
            }}
          >
            Historial de acciones
          </h3>
          <p>
            Este manual permite intepretar, filtrar y detallar la bitácora de
            acciones de los usuarios del backoffice.
          </p>
          <object
            data="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20HISTORIAL%20DE%20ACCIONES.pdf"
            type="application/pdf"
            width="100%"
            height="100%"
          >
            <p>
              Descarga alternativa:{" "}
              <a href="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20HISTORIAL%20DE%20ACCIONES.pdf">
                Si no se ve puede dar click aquí para descargar el PDF
              </a>
            </p>
          </object>
        </>
      )}
    </div>
  );
};
